// src/services/newAssetRequestService.js
// Wraps /api/new-asset-requests/* backend calls.

import { api } from './api';

export const newAssetRequestService = {
  create: (data) =>
    api.post('/api/new-asset-requests/', data),

  getAll: (status) =>
    api.get('/api/new-asset-requests/' + (status ? '?status=' + status : '')),

  getMy: () =>
    api.get('/api/new-asset-requests/my'),

  approve: (requestId, comments) =>
    api.put('/api/new-asset-requests/' + requestId + '/approve', { comments }),

  reject: (requestId, comments) =>
    api.put('/api/new-asset-requests/' + requestId + '/reject', { comments }),
};